<template>
  <div class="contact-data policy-view split-view fill-height">
    <v-row class="split-view__row fill-height" no-gutters>
      <left-side-image />
      <v-col cols="12" md="7" class="split-view__panel">
        <div class="split-view__scroll">
        <nav-bar-page />

        <v-container>
          <v-row justify="center" class="mt-0">
            <v-col cols="12" class="mt-0 py-0">
              <v-stepper alt-labels elevation="0">
                <v-stepper-header>
                  <v-stepper-step step="" class="active-step today-medium">
                    Póliza
                  </v-stepper-step>

                  <v-divider inset class="grey-separator-step"></v-divider>

                  <v-stepper-step step="" class="grey-step today-medium">
                    Simulador
                  </v-stepper-step>

                  <v-divider class="grey-separator-step"></v-divider>

                  <v-stepper-step step="" class="grey-step today-medium">
                    Formulario
                  </v-stepper-step>

                  <v-divider class="grey-separator-step"></v-divider>

                  <v-stepper-step step="" class="grey-step today-medium">
                    Firma de documentos
                  </v-stepper-step>

                  <v-divider class="grey-separator-step"></v-divider>

                  <v-stepper-step step="" class="grey-step today-medium">
                    Pago
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
            <v-col class="text-center justify-center d-flex d-sm-none">
              <div class="text-h6 today-medium primary--text">Pólizas</div>
            </v-col>
          </v-row>

          <template v-if="policiesLoading">
            <div class="d-flex justify-center mt-6">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
                aria-label="Cargando pólizas"
              ></v-progress-circular>
            </div>
          </template>
          <template v-else-if="messageNoPolicies">
            <p class="policy-empty today-light primary--text">
              Aún no tienes asociada ninguna póliza. Comunícate con un asesor.
            </p>
          </template>
          <template v-else>
            <v-row justify="center">
              <v-col cols="12" md="10" class="px-4">
                <ul class="policy-list">
                  <li
                    v-for="policy in policies"
                    :key="policy.id"
                    class="policy-list__item"
                  >
                    <v-card
                      class="policy-card"
                      outlined
                      :class="{
                        'policy-card--disabled': validatePolicyStatus(policy),
                      }"
                      :disabled="validatePolicyStatus(policy)"
                      role="button"
                      :tabindex="validatePolicyStatus(policy) ? -1 : 0"
                      :aria-disabled="validatePolicyStatus(policy) ? 'true' : 'false'"
                      :aria-label="
                        validatePolicyStatus(policy)
                          ? 'Póliza de ' + policy.insurer + ' pagada, no disponible para financiar'
                          : 'Financiar póliza de ' + policy.insurer
                      "
                      @click="goSimulator(policy.id)"
                      @keydown.enter="goSimulator(policy.id)"
                      @keydown.space.prevent="goSimulator(policy.id)"
                    >
                      <div class="policy-card__body">
                        <div class="policy-card__logo d-none d-sm-flex">
                          <v-img
                            :src="policy.image"
                            :alt="policy.insurer"
                            contain
                            width="72"
                            height="72"
                          ></v-img>
                        </div>
                        <div class="policy-card__content">
                          <h2 class="policy-card__title today-medium">
                            {{ policy.insurer }}
                          </h2>
                          <dl class="policy-card__meta">
                            <div
                              v-for="(item, itemIndex) in policy.values"
                              :key="policy.id + '-' + itemIndex"
                              class="policy-card__row"
                            >
                              <dt class="today-medium">{{ item.name }}</dt>
                              <dd class="today-regular" v-html="item.value"></dd>
                            </div>
                          </dl>
                        </div>
                        <v-icon
                          class="policy-card__chevron"
                          color="primary"
                          aria-hidden="true"
                        >
                          mdi-chevron-right
                        </v-icon>
                      </div>
                    </v-card>
                  </li>
                </ul>
              </v-col>
            </v-row>
          </template>
        </v-container>
        </div>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      max-width="400"
      overlay-color="primary"
      persistent
      content-class="policy-welcome-dialog"
    >
      <v-card class="policy-welcome-card">
        <v-img
          max-height="56"
          class="policy-welcome-card__mascot"
          contain
          alt=""
          src="https://app-biocredit.s3.amazonaws.com/vardi/obediente.png"
        ></v-img>
        <v-card-title
          class="justify-center primary--text today-medium policy-welcome-card__title"
        >
          {{ gender == "M" ? "Bienvenido" : "Bienvenida" }}
          {{ name }}
        </v-card-title>
        <p class="policy-welcome-card__hint today-light">
          A continuación encontrarás las pólizas que tienes vigentes. Selecciona
          una y empieza el proceso de financiación.
        </p>
        <div class="px-10 px-md-12 pb-8">
          <v-btn
            block
            color="primary"
            class="policy-btn policy-btn--primary today-medium"
            elevation="0"
            @click="dialog = false"
          >
            Continuar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LeftSideImage from "@/components/Layouts/LeftSideImage";
import NavBarPage from "@/components/Layouts/NavBarPage";
import { locals } from "@/helpers/locals";
import { api } from "@/helpers/axios";
import { constants } from "@/helpers/constants";

export default {
  name: "Policy",
  components: { LeftSideImage, NavBarPage },
  data() {
    return {
      dialog: false,
      user: null,
      name: "",
      gender: "",
      policies: [],
      policiesLoading: false,
      messageNoPolicies: false,
    };
  },
  created() {
    this.policiesLoading = true;
    api.get(constants.endPoints.policies, true).then((response) => {
      this.policies = [];
      this.policies = response.data.data;

      if (this.policies.length > 0) {
        this.policiesLoading = false;
        this.messageNoPolicies = false;
      } else {
        this.policiesLoading = false;
        this.messageNoPolicies = true;
      }

      console.log("this.policies", this.policies);
    });
  },
  mounted() {
    this.user = locals.getLocal("user");
    if (!this.dialog) {
      api.get(constants.endPoints.user, true).then((response) => {
        this.name = response.data.first_name;
        this.gender = response.data.gender;
        this.user.name = this.name;
        this.user.first_name = response.data.first_name;
        this.user.last_name = response.data.last_name;
        this.user.email = response.data.email;
        locals.setLocal("user", JSON.stringify(this.user));

        this.dialog = true;
        console.log(response);
      });
    }
  },
  methods: {
    goSimulator(policyId) {
      const policy = this.policies.find((item) => item.id === policyId);
      if (!policy || this.validatePolicyStatus(policy)) {
        return;
      }
      this.$router.push({
        name: "Simulator",
        params: { insurancePolicyId: policyId },
      });
    },
    validatePolicyStatus(policy) {
      if (!policy) {
        return false;
      }

      const values = Array.isArray(policy.values) ? policy.values : [];
      const statusItem =
        values.find((item) =>
          /estado/i.test(String((item && item.name) || ""))
        ) ||
        values[3] ||
        values[2];

      const candidates = [
        policy.status,
        policy.payment_status,
        statusItem && statusItem.value,
      ];

      return candidates.some((value) => {
        if (value == null || value === false) {
          return false;
        }
        const text = String(value)
          .replace(/<[^>]+>/g, " ")
          .replace(/&nbsp;/gi, " ");
        return /pagad[oa]/i.test(text);
      });
    },
  },
};
</script>

<style lang="scss">
.policy-view {
  .policy-empty {
    margin: 32px 16px 0;
    text-align: center;
    text-wrap: pretty;
  }

  .policy-list {
    list-style: none;
    margin: 8px 0 24px;
    padding: 0;
  }

  .policy-list__item + .policy-list__item {
    margin-top: 12px;
  }

  .policy-card {
    background: #f8f9fc !important;
    border: 1px solid #e6e8ee !important;
    border-radius: 16px !important;
    cursor: pointer;
    overflow: hidden;
    touch-action: manipulation;
    transition-duration: 150ms;
    transition-property: transform, background-color, border-color, box-shadow;
    transition-timing-function: ease-out;
  }

  .policy-card:hover:not(.policy-card--disabled) {
    background: #eef1f7 !important;
    border-color: #cfd5e4 !important;
    box-shadow: 0 1px 2px rgba(0, 32, 91, 0.08), 0 8px 20px rgba(0, 32, 91, 0.08);
  }

  .policy-card:active:not(.policy-card--disabled) {
    transform: scale(0.96);
  }

  .policy-card:focus-visible {
    outline: 2px solid #00205b;
    outline-offset: 3px;
  }

  .policy-card--disabled {
    cursor: not-allowed;
    opacity: 0.55;
    pointer-events: none;
  }

  .policy-card__body {
    align-items: center;
    display: flex;
    gap: 16px;
    min-width: 0;
    padding: 16px;
  }

  .policy-card__logo {
    align-items: center;
    background: #ffffff;
    border: 1px solid #e6e8ee;
    border-radius: 14px;
    flex-shrink: 0;
    height: 88px;
    justify-content: center;
    overflow: hidden;
    padding: 8px;
    width: 88px;
  }

  .policy-card__content {
    flex: 1;
    min-width: 0;
  }

  .policy-card__title {
    color: #00205b;
    font-size: 1.0625rem;
    letter-spacing: 0.01em;
    margin: 0 0 8px;
    overflow-wrap: anywhere;
    text-wrap: balance;
  }

  .policy-card__meta {
    margin: 0;
  }

  .policy-card__row {
    align-items: baseline;
    display: grid;
    gap: 8px;
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    padding: 3px 0;
  }

  .policy-card__row dt {
    color: rgba(0, 0, 0, 0.64);
    font-size: 0.8125rem;
    min-width: 0;
  }

  .policy-card__row dd {
    color: #00205b;
    font-size: 0.8125rem;
    font-variant-numeric: tabular-nums;
    margin: 0;
    min-width: 0;
    overflow-wrap: anywhere;
    text-align: right;
  }

  .policy-card__chevron {
    flex-shrink: 0;
  }
}

.policy-welcome-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  overscroll-behavior: contain;
}

.policy-welcome-card {
  border-radius: 20px !important;
  overflow: hidden;
  text-align: center;
}

.policy-welcome-card__mascot {
  margin: 28px auto 0;
}

.policy-welcome-card__title {
  padding-top: 16px !important;
  text-wrap: balance;
}

.policy-welcome-card__hint {
  color: rgba(0, 0, 0, 0.64);
  font-size: 0.875rem;
  line-height: 1.45;
  margin: 0 24px 24px;
  text-align: center;
  text-wrap: pretty;
}

.policy-btn {
  border-radius: 10px !important;
  font-size: 0.9375rem !important;
  height: 44px !important;
  letter-spacing: 0 !important;
  min-height: 44px;
  text-transform: none !important;
  touch-action: manipulation;
  transition-duration: 150ms;
  transition-property: transform, background-color, color, box-shadow, opacity;
  transition-timing-function: ease-out;
}

.policy-btn:active:not(.v-btn--disabled) {
  transform: scale(0.96);
}

.policy-btn--primary {
  background: #00205b !important;
  box-shadow: 0 1px 2px rgba(0, 32, 91, 0.18), 0 6px 16px rgba(0, 32, 91, 0.12);
  color: #ffffff !important;
}

.policy-btn--primary:hover:not(.v-btn--disabled) {
  background: #001846 !important;
}

.policy-btn:focus-visible {
  outline: 2px solid #00205b;
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  .policy-view .policy-card,
  .policy-btn {
    transition: none;
  }

  .policy-view .policy-card:active:not(.policy-card--disabled),
  .policy-btn:active:not(.v-btn--disabled) {
    transform: none;
  }
}

.v-stepper__label {
  font-size: 13px;
}

.active-step .v-stepper__label {
  color: #00205b !important;
}

.active-step > span {
  min-width: 12px !important;
  height: 12px !important;
  width: 12px !important;
  background: #00205b !important;
}

.grey-step > span {
  min-width: 12px !important;
  height: 12px !important;
  width: 12px !important;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin-top: 29px !important;
}

.active-separator-step {
  border-color: #00205b !important;
}

.grey-separator-step {
  border-color: rgba(0, 0, 0, 0.38) !important;
}

.v-divider {
  border-width: 1px 2px 2px !important;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 29px -82px 0 !important;
}

@media (max-width: 600px) {
  .policy-view .policy-card {
    border-radius: 14px !important;
  }

  .policy-view .policy-card__body {
    padding: 14px;
  }

  .policy-view .policy-card__row {
    gap: 2px;
    grid-template-columns: 1fr;
  }

  .policy-view .policy-card__row dd {
    text-align: left;
  }

  .v-stepper--alt-labels .v-stepper__step {
    flex-basis: 120px !important;
    padding: 5px !important;
  }

  .v-divider {
    visibility: hidden;
  }
}
</style>
